const apiUrl =
  process.env.GATSBY_API_BASE_URL || "https://api.recosante.beta.gouv.fr";
export default apiUrl;
